import moment from 'moment';
import 'moment/locale/es';
import { SPANISH } from 'Constants/General';

const localeFor = (language: string) => (language === SPANISH ? 'es' : 'en');

// moment es abrevia con punto ("jul."); el diseño lo muestra sin punto ("jul")
const clean = (formatted: string) => formatted.replace(/\./g, '');

export const formatDueDate = (date: string, language: string) =>
  clean(moment(date).locale(localeFor(language)).format('DD MMM'));

export const formatNewsDate = (date: string, language: string) =>
  clean(moment(date).locale(localeFor(language)).format('DD MMM'));

// El listado admin de noticias mezcla programadas y expiradas de distintos
// años, así que aquí el año sí se muestra.
export const formatNewsAdminDate = (date: string, language: string) =>
  clean(moment(date).locale(localeFor(language)).format('DD MMM YYYY'));
